import { UserCredential } from 'firebase/auth';
import { inject, injectable } from 'inversify';
import AuthRepository from 'src/features/auth/data/AuthRepository';
import { GetSocialProfileParams } from 'src/features/auth/domain/AuthRepositoryInterface';
import { GetSocialSignUpProfileUseCaseInterface } from 'src/features/auth/domain/useCases/types';

@injectable()
class GetSocialSignUpProfileUseCase
  implements GetSocialSignUpProfileUseCaseInterface
{
  @inject(AuthRepository) private authRepository!: AuthRepository;

  async execute(params: GetSocialProfileParams): Promise<UserCredential> {
    const userCredential = await this.authRepository.getSocialProfile(params);

    return userCredential;
  }
}

export default GetSocialSignUpProfileUseCase;
